import styled from 'styled-components'

type InputWrapperProps = {
  minHeight?: string
  error?: boolean
}

export const Wrapper = styled.div`
  margin-bottom: 24px;
`

export const InputWrapper = styled.div<InputWrapperProps>`
  padding: 16px;
  border: 1px solid
    ${({ theme, error }) => (error ? theme.ds.colors.danger300 : '#e0e0e0')};
  border-radius: 8px;
  min-height: ${({ minHeight }) => minHeight || '168px'};

  @media (max-width: 959px) {
    min-height: unset;
  }
`

export const DocumentsWrapper = styled.div`
  margin-left: 1px;
  margin-right: 1px;
`

export const IncludeReportsLabel = styled.span`
  color: ${({ theme }) => theme.ds.colors.primary600};
  font-weight: 600;
`
